var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      !this.hideEmptyValues ? true : this.hideEmptyValues && _vm.item.description
    )?_c('div',{class:`${_vm.off ? 'text-decoration-line-through pasive--text' : ''}`,staticStyle:{"padding-top":"20px"}},[_c('span',[_vm._v("Desarrollo: ")])]):_vm._e(),(
      !this.hideEmptyValues ? true : this.hideEmptyValues && _vm.item.description
    )?_c('div',{class:`${_vm.off ? 'text-decoration-line-through pasive--text' : ''}`,domProps:{"innerHTML":_vm._s(_vm.item.description || '-')}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }